import React from "react";
import { useSelector } from "react-redux";
import { Button, Header, Popup } from "semantic-ui-react";
import { ControlledInput } from "../../../components/ControlledForm";
import { putPermitContact } from "../../../queries/permits";
import useApiCallWithToast from "../../../hooks/useApiCallWithToast";
import networkSelectors from "../../../selectors/network";
import { useFormContext } from "react-hook-form";
import usePermitContactInvite from "../hooks/usePermitContactInvite";

interface IEmailAddressPopup {
  contactId: number;
  permitId: number;
}

// address to enter an email address and grant access to a permit contact (needs to be within a <Form>)
export const EmailAddressPopup = (props: IEmailAddressPopup) => {
  const { contactId, permitId } = props;
  const networkHeaders = useSelector(networkSelectors.defaultHeaders);
  const { control, handleSubmit } = useFormContext();
  const { invite, loading: isInviteContactLoading } = usePermitContactInvite({ permitId, contactId });

  // mutation to update contact, then invite them to the permit
  const { run: updatePermitContactAndInvite, loading: isUpdatePermitContactAndInviteLoading } = useApiCallWithToast({
    apiCall: () => putPermitContact(networkHeaders, contactId),
    onSuccess: () => {
      invite();
    },
    queryKey: "permits",
    successMessage: "Contact updated successfully",
  });

  return (
    <Popup
      basic
      on='click'
      wide='very'
      style={{ width: "400px", padding: "15px" }}
      onClick={(e: any) => {
        e.stopPropagation(); // prevent click from opening the accordion
      }}
      trigger={
        <Button
          secondary
          content='Grant Access'
          loading={isInviteContactLoading}
          disabled={isInviteContactLoading}
          onClick={(e) => {
            e.stopPropagation(); // prevent click from opening the accordion
          }}
        />
      }
    >
      <Header>First, we need an email address</Header>
      <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <div>
          <ControlledInput name='email' label='Email' control={control} fluid />
        </div>
        <Button
          color='blue'
          content='Grant Access'
          loading={isUpdatePermitContactAndInviteLoading}
          disabled={isUpdatePermitContactAndInviteLoading}
          onClick={handleSubmit(updatePermitContactAndInvite)}
          style={{ alignSelf: "flex-end" }}
        />
      </div>
    </Popup>
  );
};
